<template>
     <div class="warp">
      <van-field
          name="客服电话"
          label="客服电话"
          readonly
          :placeholder="kePhone?kePhone:'无法获取'"
          :rules="[{ required: true, message: '请填写用户名' }]">
        <template #button>
          <van-button @click="callPhone()" color="linear-gradient(to right, #FF572B, #FF0618)" size="small">联系客服</van-button>
        </template>
      </van-field>
      <div class="tip">留下您的联系方式，我们会尽快和您联系。</div>
      <van-form @submit="onSubmit">
        <van-field
          v-model="username"
          name="username"
          required
          label="姓名"
          placeholder="请输入您的姓名"
          :rules="[{ required: true, message: '请填写姓名' }]"
        />
        <van-field
          v-model="phone"
          name="phone"
          required
          label="手机号"
          placeholder="请输入您的手机号"
          :rules="[{pattern:phoneReg, message: '请填写正确的手机号' }]"
        />
        <van-field
          v-model="message"
          name="message"
          label="留言"
          placeholder="请输入留言"
        />
        <div style="margin: 16px 12%">
          <van-button round block color="linear-gradient(to right, #FFC80D, #FF8200)" native-type="submit">
            提交
          </van-button>
        </div>
      </van-form>
    </div>
</template>
<script>
import { applyinfo , record } from "@/apis/api"
import { getUrlKey } from '@/libs/utils'
export default {
    name:"leavingCapital",
    data(){
        return{
            sysOfficeId:"",
            kePhone:"",
            username: '',
            phone: '',
            message: '',
            phoneReg: /^[1](([3][0-9])|([4][5-9])|([5][0-3,5-9])|([6][5,6])|([7][0-8])|([8][0-9])|([9][1,8,9]))[0-9]{8}$/, 
        }
    },
    mounted(){
        if(getUrlKey('phone')){
            this.kePhone = getUrlKey('phone')
        }
        if(getUrlKey('sysOfficeId')){
            this.sysOfficeId = getUrlKey('sysOfficeId');
        }
        this.record()
    },
    methods: {
        //访问记录
        record(){
            //访问记录接口 start
            let params = {
                ip:localStorage.getItem("ip"),
                sysOfficeId:this.sysOfficeId
            } 
            //访问记录
            record(params).then(()=>{})
        },
        callPhone () {
            if(this.kePhone){
                window.location.href = 'tel://' + this.kePhone;
            }else{
                this.$toast({
                    message:'请稍后再试！'
                });
            }
        },
        onSubmit(values) {
            let params = {
                sysOfficeId:this.sysOfficeId,
                name:values.username,
                remark:values.message,
                phone:values.phone,
                model:"0"
            } 
            applyinfo(params).then(res=>{
                if(res.code === 0){
                    this.$toast({
                        message:'您的信息已提交成功\n请关注我们的来电，谢谢！'
                    });
                }else{
                    this.$toast({
                        message:res.msg
                    });
                }
            })
        }
    }
}
</script>
<style scoped>
    .warp{
        padding-top: 1rem;
        background: #F7F8FA;
        position: absolute;
        top: 0;
        bottom: 0;
        width: 100%;
        font-size: .88rem;
        color: #94A3A8
    }
    .tip{
        padding: 1rem 1rem .5rem;
    }
</style>